import {UserRole} from '../../../../lib/dtos/User';

export const userRoleText: Record<UserRole, string> = {
    [UserRole.Management]: 'Ansatt',
    [UserRole.Administrator]: 'Administrator',
    [UserRole.Customer]: 'Kunde',
    [UserRole.Craftman]: 'Håndverker',
    [UserRole.Developer]: 'Utvikler',
};
